<template>
  <router-view />
</template>

<script>
export default {}
</script>

<style lang="scss">
.card-title {
  padding: 0 0 0 20px;
  font-size: 22px;
}
</style>
